import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Navbar from '../components/Navbar';
import './LegalPages.css';

function Privacy() {
  const { t } = useTranslation();
  const lastUpdated = t('privacy.lastUpdated');

  // Scrolla till toppen när sidan laddas
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Navbar />
      <div className="legal-container">
        <div className="legal-header">
          <h1>{t('privacy.title')}</h1>
          <p className="last-updated">{t('privacy.lastUpdatedLabel')} {lastUpdated}</p>
        </div>

        <div className="legal-content">
          <section className="legal-section">
            <h2>{t('privacy.sections.intro.title')}</h2>
            <p>{t('privacy.sections.intro.p1')}</p>
            <p className="highlight-box">
              <strong>{t('privacy.sections.intro.important.title')}</strong> {t('privacy.sections.intro.important.text')}
            </p>
          </section>

          <section className="legal-section">
            <h2>{t('privacy.sections.controller.title')}</h2>
            <div className="contact-box">
              <p><strong>{t('privacy.sections.controller.responsible')}</strong> Moricome - The Gathering Machine</p>
              <p><strong>{t('privacy.sections.controller.contact')}</strong> support@moricome.com</p>
              <p><strong>{t('privacy.sections.controller.website')}</strong> www.moricome.com</p>
            </div>
          </section>

          <section className="legal-section">
            <h2>{t('privacy.sections.dataCollection.title')}</h2>
            
            <h3>{t('privacy.sections.dataCollection.direct.title')}</h3>
            <div className="data-category">
              <h4>{t('privacy.sections.dataCollection.direct.accountCreation')}</h4>
              <ul>
                <li>{t('privacy.sections.dataCollection.direct.name')}</li>
                <li>{t('privacy.sections.dataCollection.direct.email')}</li>
                <li>{t('privacy.sections.dataCollection.direct.password')}</li>
                <li>{t('privacy.sections.dataCollection.direct.subscription')}</li>
              </ul>
            </div>

            <div className="data-category">
              <h4>{t('privacy.sections.dataCollection.direct.serviceUsage')}</h4>
              <ul>
                <li>{t('privacy.sections.dataCollection.direct.groupInfo')}</li>
                <li>{t('privacy.sections.dataCollection.direct.participantInfo')}</li>
                <li>{t('privacy.sections.dataCollection.direct.meetingDetails')}</li>
                <li>{t('privacy.sections.dataCollection.direct.responses')}</li>
                <li>{t('privacy.sections.dataCollection.direct.settings')}</li>
              </ul>
            </div>

            <h3>{t('privacy.sections.dataCollection.automatic.title')}</h3>
            <ul>
              <li><strong>{t('privacy.sections.dataCollection.automatic.technical')}</strong> {t('privacy.sections.dataCollection.automatic.technicalDesc')}</li>
              <li><strong>{t('privacy.sections.dataCollection.automatic.usage')}</strong> {t('privacy.sections.dataCollection.automatic.usageDesc')}</li>
              <li><strong>{t('privacy.sections.dataCollection.automatic.cookies')}</strong> {t('privacy.sections.dataCollection.automatic.cookiesDesc')}</li>
              <li><strong>{t('privacy.sections.dataCollection.automatic.emailInteractions')}</strong> {t('privacy.sections.dataCollection.automatic.emailDesc')}</li>
            </ul>

            <h3>{t('privacy.sections.dataCollection.thirdParty.title')}</h3>
            <ul>
              <li><strong>{t('privacy.sections.dataCollection.thirdParty.payment')}</strong> {t('privacy.sections.dataCollection.thirdParty.paymentDesc')}</li>
              <li><strong>{t('privacy.sections.dataCollection.thirdParty.auth')}</strong> {t('privacy.sections.dataCollection.thirdParty.authDesc')}</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>{t('privacy.sections.dataUsage.title')}</h2>
            
            <h3>{t('privacy.sections.dataUsage.legalBasis')}</h3>
            
            <div className="purpose-box">
              <h4>📧 {t('privacy.sections.dataUsage.purposes.service.title')}</h4>
              <ul>
                <li>{t('privacy.sections.dataUsage.purposes.service.li1')}</li>
                <li>{t('privacy.sections.dataUsage.purposes.service.li2')}</li>
                <li>{t('privacy.sections.dataUsage.purposes.service.li3')}</li>
                <li>{t('privacy.sections.dataUsage.purposes.service.li4')}</li>
              </ul>
            </div>

            <div className="purpose-box">
              <h4>💳 {t('privacy.sections.dataUsage.purposes.payment.title')}</h4>
              <ul>
                <li>{t('privacy.sections.dataUsage.purposes.payment.li1')}</li>
                <li>{t('privacy.sections.dataUsage.purposes.payment.li2')}</li>
                <li>{t('privacy.sections.dataUsage.purposes.payment.li3')}</li>
              </ul>
            </div>

            <div className="purpose-box">
              <h4>🔒 {t('privacy.sections.dataUsage.purposes.security.title')}</h4>
              <ul>
                <li>{t('privacy.sections.dataUsage.purposes.security.li1')}</li>
                <li>{t('privacy.sections.dataUsage.purposes.security.li2')}</li>
                <li>{t('privacy.sections.dataUsage.purposes.security.li3')}</li>
              </ul>
            </div>

            <div className="purpose-box">
              <h4>📊 {t('privacy.sections.dataUsage.purposes.improvement.title')}</h4>
              <ul>
                <li>{t('privacy.sections.dataUsage.purposes.improvement.li1')}</li>
                <li>{t('privacy.sections.dataUsage.purposes.improvement.li2')}</li>
                <li>{t('privacy.sections.dataUsage.purposes.improvement.li3')}</li>
              </ul>
            </div>

            <div className="purpose-box">
              <h4>📢 {t('privacy.sections.dataUsage.purposes.communication.title')}</h4>
              <ul>
                <li>{t('privacy.sections.dataUsage.purposes.communication.li1')}</li>
                <li>{t('privacy.sections.dataUsage.purposes.communication.li2')}</li>
                <li>{t('privacy.sections.dataUsage.purposes.communication.li3')}</li>
              </ul>
            </div>
          </section>

          <section className="legal-section">
            <h2>{t('privacy.sections.dataSharing.title')}</h2>
            
            <h3>{t('privacy.sections.dataSharing.when')}</h3>
            <p>{t('privacy.sections.dataSharing.intro')}</p>

            <div className="sharing-category">
              <h4>{t('privacy.sections.dataSharing.providers.title')}</h4>
              <ul>
                <li><strong>{t('privacy.sections.dataSharing.providers.email')}</strong> {t('privacy.sections.dataSharing.providers.emailDesc')}</li>
                <li><strong>{t('privacy.sections.dataSharing.providers.payment')}</strong> {t('privacy.sections.dataSharing.providers.paymentDesc')}</li>
                <li><strong>{t('privacy.sections.dataSharing.providers.hosting')}</strong> {t('privacy.sections.dataSharing.providers.hostingDesc')}</li>
                <li><strong>{t('privacy.sections.dataSharing.providers.database')}</strong> {t('privacy.sections.dataSharing.providers.databaseDesc')}</li>
                <li><strong>{t('privacy.sections.dataSharing.providers.analytics')}</strong> {t('privacy.sections.dataSharing.providers.analyticsDesc')}</li>
              </ul>
              <p className="note">{t('privacy.sections.dataSharing.providers.note')}</p>
            </div>

            <div className="sharing-category">
              <h4>{t('privacy.sections.dataSharing.legal.title')}</h4>
              <ul>
                <li>{t('privacy.sections.dataSharing.legal.li1')}</li>
                <li>{t('privacy.sections.dataSharing.legal.li2')}</li>
                <li>{t('privacy.sections.dataSharing.legal.li3')}</li>
                <li>{t('privacy.sections.dataSharing.legal.li4')}</li>
              </ul>
            </div>

            <div className="sharing-category">
              <h4>{t('privacy.sections.dataSharing.business.title')}</h4>
              <p>{t('privacy.sections.dataSharing.business.text')}</p>
            </div>

            <h3>{t('privacy.sections.dataSharing.international.title')}</h3>
            <p>{t('privacy.sections.dataSharing.international.intro')}</p>
            <ul>
              <li>{t('privacy.sections.dataSharing.international.li1')}</li>
              <li>{t('privacy.sections.dataSharing.international.li2')}</li>
              <li>{t('privacy.sections.dataSharing.international.li3')}</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>{t('privacy.sections.retention.title')}</h2>
            
            <table className="retention-table">
              <thead>
                <tr>
                  <th>{t('privacy.sections.retention.table.type')}</th>
                  <th>{t('privacy.sections.retention.table.period')}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{t('privacy.sections.retention.table.account')}</td>
                  <td>{t('privacy.sections.retention.table.accountPeriod')}</td>
                </tr>
                <tr>
                  <td>{t('privacy.sections.retention.table.meetingHistory')}</td>
                  <td>{t('privacy.sections.retention.table.meetingHistoryPeriod')}</td>
                </tr>
                <tr>
                  <td>{t('privacy.sections.retention.table.participantData')}</td>
                  <td>{t('privacy.sections.retention.table.participantDataPeriod')}</td>
                </tr>
                <tr>
                  <td>{t('privacy.sections.retention.table.paymentHistory')}</td>
                  <td>{t('privacy.sections.retention.table.paymentHistoryPeriod')}</td>
                </tr>
                <tr>
                  <td>{t('privacy.sections.retention.table.logs')}</td>
                  <td>{t('privacy.sections.retention.table.logsPeriod')}</td>
                </tr>
                <tr>
                  <td>{t('privacy.sections.retention.table.analytics')}</td>
                  <td>{t('privacy.sections.retention.table.analyticsPeriod')}</td>
                </tr>
              </tbody>
            </table>

            <p className="note">{t('privacy.sections.retention.note')}</p>
          </section>

          <section className="legal-section">
            <h2>{t('privacy.sections.cookies.title')}</h2>
            
            <h3>{t('privacy.sections.cookies.what.title')}</h3>
            <p>{t('privacy.sections.cookies.what.text')}</p>

            <h3>{t('privacy.sections.cookies.types.title')}</h3>
            
            <div className="cookie-category">
              <h4>🔐 {t('privacy.sections.cookies.types.necessary.title')}</h4>
              <ul>
                <li><strong>{t('privacy.sections.cookies.types.necessary.auth')}</strong> {t('privacy.sections.cookies.types.necessary.authDesc')}</li>
                <li><strong>{t('privacy.sections.cookies.types.necessary.security')}</strong> {t('privacy.sections.cookies.types.necessary.securityDesc')}</li>
                <li><strong>{t('privacy.sections.cookies.types.necessary.session')}</strong> {t('privacy.sections.cookies.types.necessary.sessionDesc')}</li>
              </ul>
              <p><em>{t('privacy.sections.cookies.types.necessary.retention')}</em></p>
            </div>

            <div className="cookie-category">
              <h4>📊 {t('privacy.sections.cookies.types.analytical.title')}</h4>
              <ul>
                <li><strong>{t('privacy.sections.cookies.types.analytical.ga')}</strong> {t('privacy.sections.cookies.types.analytical.gaDesc')}</li>
                <li><strong>{t('privacy.sections.cookies.types.analytical.stats')}</strong> {t('privacy.sections.cookies.types.analytical.statsDesc')}</li>
              </ul>
              <p><em>{t('privacy.sections.cookies.types.analytical.retention')}</em></p>
            </div>

            <div className="cookie-category">
              <h4>🎯 {t('privacy.sections.cookies.types.functional.title')}</h4>
              <ul>
                <li><strong>{t('privacy.sections.cookies.types.functional.language')}</strong> {t('privacy.sections.cookies.types.functional.languageDesc')}</li>
                <li><strong>{t('privacy.sections.cookies.types.functional.preferences')}</strong> {t('privacy.sections.cookies.types.functional.preferencesDesc')}</li>
              </ul>
              <p><em>{t('privacy.sections.cookies.types.functional.retention')}</em></p>
            </div>

            <h3>{t('privacy.sections.cookies.manage.title')}</h3>
            <p>{t('privacy.sections.cookies.manage.intro')}</p>
            <ul>
              <li>{t('privacy.sections.cookies.manage.li1')}</li>
              <li>{t('privacy.sections.cookies.manage.li2')}</li>
              <li>{t('privacy.sections.cookies.manage.li3')}</li>
            </ul>
            <p className="note">{t('privacy.sections.cookies.manage.note')}</p>
          </section>

          <section className="legal-section">
            <h2>{t('privacy.sections.rights.title')}</h2>
            
            <p>{t('privacy.sections.rights.intro')}</p>

            <div className="rights-list">
              <div className="right-item">
                <h4>📋 {t('privacy.sections.rights.access.title')}</h4>
                <p>{t('privacy.sections.rights.access.text')}</p>
              </div>

              <div className="right-item">
                <h4>✏️ {t('privacy.sections.rights.rectification.title')}</h4>
                <p>{t('privacy.sections.rights.rectification.text')}</p>
              </div>

              <div className="right-item">
                <h4>🗑️ {t('privacy.sections.rights.erasure.title')}</h4>
                <p>{t('privacy.sections.rights.erasure.text')}</p>
              </div>

              <div className="right-item">
                <h4>🚫 {t('privacy.sections.rights.restriction.title')}</h4>
                <p>{t('privacy.sections.rights.restriction.text')}</p>
              </div>

              <div className="right-item">
                <h4>📤 {t('privacy.sections.rights.portability.title')}</h4>
                <p>{t('privacy.sections.rights.portability.text')}</p>
              </div>

              <div className="right-item">
                <h4>⛔ {t('privacy.sections.rights.object.title')}</h4>
                <p>{t('privacy.sections.rights.object.text')}</p>
              </div>

              <div className="right-item">
                <h4>🙅 {t('privacy.sections.rights.withdraw.title')}</h4>
                <p>{t('privacy.sections.rights.withdraw.text')}</p>
              </div>

              <div className="right-item">
                <h4>⚖️ {t('privacy.sections.rights.complaint.title')}</h4>
                <p>{t('privacy.sections.rights.complaint.text')}</p>
                <p className="contact-info" dangerouslySetInnerHTML={{ __html: t('privacy.sections.rights.complaint.authority') }} />
              </div>
            </div>

            <h3>{t('privacy.sections.rights.howTo.title')}</h3>
            <p dangerouslySetInnerHTML={{ __html: t('privacy.sections.rights.howTo.text') }} />
          </section>

          <section className="legal-section">
            <h2>{t('privacy.sections.security.title')}</h2>
            
            <h3>{t('privacy.sections.security.protection.title')}</h3>
            <ul>
              <li><strong>{t('privacy.sections.security.protection.encryption')}</strong> {t('privacy.sections.security.protection.encryptionDesc')}</li>
              <li><strong>{t('privacy.sections.security.protection.passwords')}</strong> {t('privacy.sections.security.protection.passwordsDesc')}</li>
              <li><strong>{t('privacy.sections.security.protection.access')}</strong> {t('privacy.sections.security.protection.accessDesc')}</li>
              <li><strong>{t('privacy.sections.security.protection.backup')}</strong> {t('privacy.sections.security.protection.backupDesc')}</li>
              <li><strong>{t('privacy.sections.security.protection.monitoring')}</strong> {t('privacy.sections.security.protection.monitoringDesc')}</li>
              <li><strong>{t('privacy.sections.security.protection.updates')}</strong> {t('privacy.sections.security.protection.updatesDesc')}</li>
            </ul>

            <h3>{t('privacy.sections.security.breach.title')}</h3>
            <p>{t('privacy.sections.security.breach.intro')}</p>
            <ul>
              <li>{t('privacy.sections.security.breach.li1')}</li>
              <li>{t('privacy.sections.security.breach.li2')}</li>
              <li>{t('privacy.sections.security.breach.li3')}</li>
              <li>{t('privacy.sections.security.breach.li4')}</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>{t('privacy.sections.children.title')}</h2>
            <p>{t('privacy.sections.children.p1')}</p>
            <p>{t('privacy.sections.children.p2')}</p>
          </section>

          <section className="legal-section">
            <h2>{t('privacy.sections.changes.title')}</h2>
            <p>{t('privacy.sections.changes.intro')}</p>
            <ul>
              <li>{t('privacy.sections.changes.li1')}</li>
              <li>{t('privacy.sections.changes.li2')}</li>
              <li>{t('privacy.sections.changes.li3')}</li>
            </ul>
            <p>{t('privacy.sections.changes.recommendation')}</p>
          </section>

          <section className="legal-section">
            <h2>{t('privacy.sections.contact.title')}</h2>
            <p>{t('privacy.sections.contact.intro')}</p>
            <div className="contact-box">
              <p><strong>{t('privacy.sections.contact.email')}</strong> support@moricome.com</p>
              <p><strong>{t('privacy.sections.contact.website')}</strong> www.moricome.com</p>
              <p><strong>{t('privacy.sections.contact.responseTime')}</strong> {t('privacy.sections.contact.responseTimeText')}</p>
            </div>
          </section>

          <div className="legal-footer">
            <p>
              {t('privacy.footer.text')} <Link to="/terms">{t('privacy.footer.termsLink')}</Link>.
            </p>
          </div>
        </div>

        <div className="back-link">
          <Link to="/hur">{t('privacy.backLink')}</Link>
        </div>
      </div>
    </>
  );
}

export default Privacy;